import { useCallback, useMemo } from "react";
import { companyDefaultLogo } from "../../../utils/constant";
import { Img } from "./CompanyLogo.styled";
import { ICompanyLogo } from "../../../types/search";
import { S3ImageBaseUrl } from "@findemdev/findem-helpers";
import { HandleOnLoad } from "./types/companyLogo";

interface ICompanyLogoProps {
  link: string | undefined;
  width: string;
  height: string;
  binUrl?: string | undefined; // in some cases a binary string is provided
  borderRadius?: string;
  companyLogos?: ICompanyLogo[];
  companyName?: string | undefined;
  styleProps?: React.CSSProperties | undefined;
  handleOnLoad?: HandleOnLoad;
}

const CompanyLogo = ({
  link,
  width,
  height,
  binUrl,
  borderRadius,
  companyLogos,
  companyName,
  styleProps,
  handleOnLoad,
}: ICompanyLogoProps) => {

  const imgOnError = useCallback((ev: React.MouseEvent<HTMLImageElement>) => {
    const target = ev.target as HTMLImageElement;
    target.src = companyDefaultLogo;
  }, []);

  const imgSrc = useMemo(() =>
    link
      ? link.startsWith('https://')
        ? link
        : `${S3ImageBaseUrl}/${link}.jpg`
      : undefined
    , [link]);

const returnCompanyIconLink = useCallback((company_name: string | undefined) => {
    if (company_name && company_name.length > 0) {
      return `${S3ImageBaseUrl}/${company_name}.jpg`;
    }
    return undefined;
  }, []);

  const companyLogo: string = useMemo(() => {
    if (binUrl) { // give precedence to the binary string
      return binUrl;
    }

    if (imgSrc) {
      return imgSrc;
    }
    const logo = companyLogos?.find((logo: ICompanyLogo) => logo.source === 'linkedin')?.ref ??
      companyName?.toLowerCase() ??
      companyDefaultLogo;

    return returnCompanyIconLink(logo) ?? "undefined";
  }, [companyLogos, imgSrc, companyName, binUrl]);

  const handleImageLoad = useCallback((event: React.SyntheticEvent<HTMLImageElement>) => {
    const img = event.currentTarget;

    if (handleOnLoad) {
      handleOnLoad({
        img
      })
    }

  }, [handleOnLoad]);

  return (
    <Img
      id={link ? link : ''}
      src={companyLogo}
      width={width}
      height={height}
      alt='company_logo'
      onError={imgOnError}
      onLoad={handleImageLoad}
      style={styleProps ?? {}}
      $borderRadius={borderRadius}
    />
  );
};

export default CompanyLogo;